import React, { ReactNode } from 'react';
import styles from './assets/emails-log-list-screen.module.scss';
import classNames from 'classnames';
import EmailsLogGrid from './components/EmailsLogGrid';
import { Paginated } from 'src/services/api-handlers/pagination';
import { QueryParams } from 'src/types/grid';

import AdminLayout from 'src/components/layout/RoleLayout';
import { IEmailLog } from 'src/types/email-log';

export interface StateProps {
    data: Paginated<IEmailLog>;
}

export interface DispatchProps {
    getData: (params: QueryParams) => void;
}

export interface OwnProps {}

export interface Props extends StateProps, DispatchProps, OwnProps {}

class ServiceTypeListScreen extends React.Component<Props> {
    public render(): ReactNode {
        const { data, getData } = this.props;

        return (
            <AdminLayout>
                <div className={`${classNames(styles.pageHeading)} ${'pageHeading'}`}>
                    <h2 className={`${classNames(styles.pageHeadingTitle)} ${'pageHeadingTitle'}`}>
                        EMAILS LOG {data.totalCount ? '(' + data.totalCount + ')' : ''}
                    </h2>
                </div>
                <div className={classNames(styles.list)}>
                    <EmailsLogGrid data={data} getData={getData} />
                </div>
            </AdminLayout>
        );
    }
}

export default ServiceTypeListScreen;
